import {
  MapFeatureType,
  useFeatureInteractionContext,
} from 'features/siteMap/contexts/FeatureInteractionContext'
import { SelectCoordinatesOnMapButton } from 'features/siteMap/popupMenus/editMode/editFeature/SelectCoordinatesOnMapButton'
import { SVNumberInput } from 'features/siteMap/popupMenus/editMode/editFeature/SVNumberInput'
import { useTilesetMapFeatureHelpers } from 'features/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import isNil from 'lodash/isNil'
import React, { FC } from 'react'
import styled from 'styled-components'
import { SiteFeaturePrimitive } from 'types'

const CoordinateInputs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: left;
  align-items: center;
`

interface CoordinateInputSectionProps {
  feature: SiteFeaturePrimitive
  featureType: MapFeatureType
}

export const CoordinateInputSection: FC<CoordinateInputSectionProps> = (
  props
) => {
  const { setSelectedFeature } = useFeatureInteractionContext()
  const { updateFeaturePrimitive } = useTilesetMapFeatureHelpers()

  return (
    <CoordinateInputs>
      <SelectCoordinatesOnMapButton
        feature={{ primitive: props.feature, type: props.featureType }}
        minimized={true}
      />
      lat:
      <SVNumberInput
        id='lat'
        value={props.feature.coordinate.lat}
        step={0.00001}
        width={100}
        onChange={(e) => {
          const newFeaturePrimitive = {
            ...props.feature,
            coordinate: {
              ...props.feature.coordinate,
              lat: parseFloat(e.target.value),
            },
          }
          updateFeaturePrimitive(newFeaturePrimitive, 'coordinate.lat')
          setSelectedFeature(
            isNil(newFeaturePrimitive.unit_id)
              ? {
                  type: MapFeatureType.Unknown,
                  featureID: newFeaturePrimitive.id,
                }
              : {
                  type: MapFeatureType.Unit,
                  unitID: newFeaturePrimitive.unit_id,
                }
          )
        }}
      />
      lon:
      <SVNumberInput
        id='lon'
        value={props.feature.coordinate.lon}
        step={0.00001}
        width={100}
        onChange={(e) => {
          const newFeaturePrimitive = {
            ...props.feature,
            coordinate: {
              ...props.feature.coordinate,
              lon: parseFloat(e.target.value),
            },
          }
          updateFeaturePrimitive(newFeaturePrimitive, 'coordinate.lon')
          setSelectedFeature(
            isNil(newFeaturePrimitive.unit_id)
              ? {
                  type: MapFeatureType.Unknown,
                  featureID: newFeaturePrimitive.id,
                }
              : {
                  type: MapFeatureType.Unit,
                  unitID: newFeaturePrimitive.unit_id,
                }
          )
        }}
      />
      alt:
      <SVNumberInput
        id='alt'
        value={props.feature.coordinate.height}
        step={0.5}
        width={60}
        onChange={(e) => {
          const newFeaturePrimitive = {
            ...props.feature,
            coordinate: {
              ...props.feature.coordinate,
              height: parseFloat(e.target.value),
            },
          }
          updateFeaturePrimitive(newFeaturePrimitive, 'coordinate.height')
          setSelectedFeature(
            isNil(newFeaturePrimitive.unit_id)
              ? {
                  type: MapFeatureType.Unknown,
                  featureID: newFeaturePrimitive.id,
                }
              : {
                  type: MapFeatureType.Unit,
                  unitID: newFeaturePrimitive.unit_id,
                }
          )
        }}
      />
    </CoordinateInputs>
  )
}
